// Shared field helpers + renderer for CMS editors (solutions, sectors, homepage).

export const listToText = (arr) => (Array.isArray(arr) ? arr.join("\n") : "");
export const textToList = (txt) => (txt || "").split("\n").map((s) => s.trim()).filter(Boolean);

export const faqToText = (arr) =>
  Array.isArray(arr) ? arr.map((f) => `${f.q || ""} :: ${f.a || ""}`).join("\n") : "";
export const textToFaq = (txt) =>
  (txt || "").split("\n").map((l) => l.trim()).filter(Boolean).map((l) => {
    const [q, ...rest] = l.split("::");
    return { q: (q || "").trim(), a: rest.join("::").trim() };
  });

import { useAdminLang, useLabel } from "./adminLang";

const inputCls =
  "w-full bg-white/5 border border-white/15 rounded-xl px-3.5 py-2.5 text-sm text-white focus:outline-none focus:border-[#FF6600]";

// Renders a single field. `value`/`onChange` operate on the live JS value
// (string for text/textarea, array for list/faq/objlist).
export const Field = ({ field, value, onChange }) => {
  const L = useLabel();
  const label = L(field.label || field.key);
  const testid = `field-${field.key}`;

  if (field.type === "textarea") {
    return (
      <Wrap label={label}>
        <textarea rows={field.rows || 3} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className={inputCls} data-testid={testid} />
      </Wrap>
    );
  }
  if (field.type === "list") {
    return (
      <Wrap label={label}>
        <textarea rows={field.rows || 4} value={listToText(value)} onChange={(e) => onChange(textToList(e.target.value))} className={inputCls} data-testid={testid} />
      </Wrap>
    );
  }
  if (field.type === "faq") {
    return (
      <Wrap label={label}>
        <textarea rows={4} value={faqToText(value)} onChange={(e) => onChange(textToFaq(e.target.value))} className={inputCls} data-testid={testid} />
      </Wrap>
    );
  }
  if (field.type === "objlist") {
    const rows = Array.isArray(value) ? value : [];
    const update = (i, k, v) => onChange(rows.map((r, idx) => (idx === i ? { ...r, [k]: v } : r)));
    const remove = (i) => onChange(rows.filter((_, idx) => idx !== i));
    const add = () => onChange([...rows, Object.fromEntries(field.sub.map((s) => [s.key, ""]))]);
    return (
      <Wrap label={label}>
        <div className="space-y-3">
          {rows.map((r, i) => (
            <div key={i} className="bg-white/[0.03] border border-white/10 rounded-xl p-3 space-y-2" data-testid={`${testid}-item-${i}`}>
              {field.sub.map((s) => (
                <input key={s.key} placeholder={L(s.label)} value={r[s.key] ?? ""} onChange={(e) => update(i, s.key, e.target.value)} className={inputCls} data-testid={`${testid}-${i}-${s.key}`} />
              ))}
              <button type="button" onClick={() => remove(i)} className="text-[11px] font-bold text-red-400 hover:text-red-300" data-testid={`${testid}-remove-${i}`}>{L("Retirer")}</button>
            </div>
          ))}
          <button type="button" onClick={add} className="text-xs font-bold text-[#FF9900] border border-[#FF6600]/40 rounded-xl px-4 py-2 hover:bg-[#FF6600]/10" data-testid={`${testid}-add`}>{L("+ Ajouter")}</button>
        </div>
      </Wrap>
    );
  }
  // text
  return (
    <Wrap label={label}>
      <input value={value ?? ""} onChange={(e) => onChange(e.target.value)} className={inputCls} data-testid={testid} />
    </Wrap>
  );
};

const Wrap = ({ label, children }) => (
  <div>
    <label className="block text-[11px] font-bold uppercase tracking-wider text-white/45 mb-1.5">{label}</label>
    {children}
  </div>
);
